export default __webpack_public_path__ + "static/media/closet4-1920w.54b4487a.avif";